import React from "react";
import { CalendarDays, Loader2 } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";

const slotClass = (isBooked, isSelected) => {
  if (isBooked) return "border-white/5 text-white/25 line-through cursor-not-allowed";
  if (isSelected) return "bg-white text-black border-white";
  return "border-white/15 text-white/85 hover:border-white/60";
};

export const DateSlotPicker = ({ date, setDate, availability, loadingSlots, form, setForm, today }) => (
  <div className="lg:col-span-5 bg-[#0E0E0E] p-6 md:p-10">
    <div className="flex items-center gap-2 overline mb-5">
      <CalendarDays size={14} /> Select a date
    </div>

    <div className="border border-white/10 bg-[#080808] p-2 inline-block w-full">
      <Calendar
        mode="single"
        selected={date}
        onSelect={setDate}
        disabled={(d) => d < today}
        fromDate={today}
        className="text-white"
        data-testid="booking-calendar"
      />
    </div>

    <div className="mt-8">
      <div className="overline mb-4">Available time slots</div>
      {!date && (
        <p className="text-sm text-white/45" data-testid="booking-no-date">
          Choose a date above to view available slots.
        </p>
      )}
      {date && loadingSlots && (
        <div className="flex items-center gap-2 text-sm text-white/55">
          <Loader2 size={14} className="animate-spin" /> Checking availability…
        </div>
      )}
      {date && !loadingSlots && availability && (
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-2" data-testid="booking-slots">
          {availability.all_slots.map((slot) => {
            const isBooked = availability.booked_slots.includes(slot);
            const isSelected = form.time === slot;
            return (
              <button
                key={slot}
                type="button"
                disabled={isBooked}
                onClick={() => setForm((f) => ({ ...f, time: slot }))}
                data-testid={`booking-slot-${slot}`}
                className={`py-2.5 text-xs tracking-wider border transition-colors duration-200 ${slotClass(isBooked, isSelected)}`}
              >
                {slot}
              </button>
            );
          })}
        </div>
      )}
    </div>
  </div>
);
